import React from 'react';

/*
  Página FAQ SIGAA - Bruna
*/

const CreditsSigaa: React.FC = () => {
  return (
    <>
      <h3>Onde foram parar meus créditos?</h3>
      <p>
        O SIGAA não utiliza o padrão já conhecido de créditos que a UnB e o MW
        usavam. Agora, foi adotado um padrão de hora/aula. Cada crédito
        corresponde a 15 horas/aula, ou seja, uma disciplina de 2 créditos
        corresponde a 30 horas/aula, e assim por diante. Caso queira fazer a
        conversão inversa, basta dividir o número total de horas/aula por 15.
      </p>
    </>
  );
};

export default CreditsSigaa;
